import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveCompanyStateRegistrationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveStateRegistrationParam } from 'api/types/params/onboarding/legalClientSaveStateRegistrationParam';

import { parseLegalClientRepresentative } from '../helpers';

export const useLegalClientRepresentativeSaveCompanyStateRegistration = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveCompanyStateRegistrationMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeSaveCompanyStateRegistration
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeSaveCompanyStateRegistration
        )
      : undefined,
    loading,
    error,
    saveStateRegistration: useCallback(
      async (id: string, params: LegalClientSaveStateRegistrationParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.legalClientRepresentativeSaveCompanyStateRegistration
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeSaveCompanyStateRegistration
            )
          : undefined;
      },
      [handle]
    ),
  };
};
